import { render, staticRenderFns } from "./select-district.vue?vue&type=template&id=585b02ae&"
import script from "./select-district.vue?vue&type=script&lang=js&"
export * from "./select-district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports